
import Cpts001 from '@/components/lyx-components/cpts001/index.vue'
import Cpts002 from '@/components/lyx-components/cpts002/index.vue'
import Cpts003 from '@/components/public-components/cpts003/index.vue'
import Cpts020 from '@/components/public-components/loading/index.vue'
import Cpts029 from '@/components/public-components/cpts029/index.vue'
import Footer from "@/components/lyx-components/lyx-footer/index"

import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import util from '@/javascript/util'
import bus from '@/javascript/bus'
import EsQuery from '@/javascript/esQuery'
import goBack from '@/components/public-components/goBack/index.vue'

export default {
directives: {
TransferDom
},
components: {
Confirm,
Cpts001,
Cpts002,
Cpts003,
Cpts020,
Cpts029,
goBack,
Footer
},
data () {
return {
isWeixin: util.isWeiXin(),
isLogin: Boolean(bus.userInfo.access_token),
passWord: {
identiferId: '',
articleSite: '',
moduleCode: 3001,
collTypes: this.XQSC_TYPE_CODE.GL,
name: '',
picUrl: '',
appCode: 71
},
strategyEntity: {},
tabCur: this.$route.params.tab,
tabsSticky: false,
banner: '',
code: '',
currentName: this.$route.params.name,
travelsList: [],
infiniteStatus: false,
infiniteAll: false,
travelsListPageNo: 0,
travelsListPageSize: 10,
travelsListTabs: [],
travelsListTabsCur: this.$route.params.tag ? this.$route.params.tag : 0,
strategyId: '',
strategyContent: {},
minHeight: 0
}
},
created () {
this.passWord.articleSite = window.location.pathname + window.location.hash
},
mounted () {
this.minHeight = document.documentElement.clientHeight - this.$refs.topHead.offsetHeight + 0.2 * 50

/**
* 标签
*/




this.getTravelsList()
this.initData()


/**
* 页面滚动
*/
window.addEventListener('scroll', this.windowScroll)
},
watch: {
"$route": {
handler (val) {
this.travelsListTabsCur = val.params.tag
this.travelsListPageNo = 0
this.infiniteAll = false
this.infiniteStatus = false
this.travelsList = []
if (this.tabCur == val.params.tab) {
this.getTravelsList(true)
} else {
this.tabCur = val.params.tab
this.getTravelsList()
}

this.initData()
}
}
},
methods: {
initData: function () {
/**
* 攻略
*/
const strategyEsQuery = new EsQuery()
const querystring2 = require('querystring');
strategyEsQuery.addKeyword("title", this.currentName, strategyEsQuery.and, true)

const strategyEsJsonQuery = JSON.stringify(strategyEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring2.stringify({
indexName: this.INDEX_NAME_TYPE.strList,
esJsonQuery: strategyEsJsonQuery
})).then((response) => {

if (response.data.data.length > 0) {

this.strategyId = response.data.data[0]._id
this.strategyContent = response.data.data[0]._source
this.strategyContent.catalogList = []
document.title = this.strategyContent.title
this.strategyContent.catalog.map(item => {
if (Object.prototype.toString.call(item) == '[object Array]') {
this.strategyContent.catalogList.push(...item)
} else {
this.strategyContent.catalogList.push(item)
}
})
if (this.code) {
this.banner = this.STATIC_BASE_URL + '/images/city-banner/' + this.code + '.png'
} else {
this.banner = this.PIC_BASE_URL + response.data.data[0]._source.titleImage
}
}

const resData = response.data.data[0]._source,
strategyEntity = {}

strategyEntity.titleImage = resData.titleImage
strategyEntity.serviceType = 100
strategyEntity.description = resData.description
strategyEntity.title = resData.title

this.$set(this, 'strategyEntity', strategyEntity)

this.passWord.identiferId = this.strategyId
this.passWord.name = this.$route.params.name
this.passWord.picUrl = this.code ? ('/images/city-banner/' + this.code + '.png') : response.data.data[0]._source.titleImage
if (bus.userInfo.user) {
const userInfo = bus.userInfo.user,
history = {
catalog: this.XQSC_TYPE_CODE.GL,
serviceType: this.SERVICE_TYPE.GL,
title: this.$route.params.name,
url: this.$route.path,
userId: userInfo.id,
username: userInfo.username,
picUrl: this.banner
}
bus.$set(bus, 'history', history)
} else {
console.log('token过期');
}
}).then(() => {

/**
* 微信签名分享
*/













})
},
windowScroll: function () {
if (this.tabCur == 1) {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
if (!this.$refs.stickyBox) {
return
}
if (scrollTop >= this.$refs.stickyBox.offsetTop) {
this.tabsSticky = true
} else {
this.tabsSticky = false
}
}


if (util.pullUpLoad() && this.travelsList.length > 0) {
this.infinite()
}
},
getTravelsList: function (status) {
const travelsEsQuery = new EsQuery()
const querystring2 = require('querystring');
travelsEsQuery.addKeyword("tags", this.currentName, travelsEsQuery.and, false)
if (this.travelsListTabsCur != 0) {
travelsEsQuery.addKeyword("tags", this.travelsListTabs[this.travelsListTabsCur], travelsEsQuery.and, false)
}
travelsEsQuery.addPage(this.travelsListPageNo, this.travelsListPageSize)
const travelsEsJsonQuery = JSON.stringify(travelsEsQuery.getArray())
this.$http.post('/api/wtcp-kb/pub/doc/search', querystring2.stringify({
indexName: this.INDEX_NAME_TYPE.travelList,
esJsonQuery: travelsEsJsonQuery
})).then((response) => {

this.travelsList = this.travelsList.concat(response.data.data)
if (response.data.data.length < this.travelsListPageSize) {
this.infiniteAll = true
}
this.infiniteStatus = false
}).then(() => {
if (status && this.$refs.stickyBox) {
window.scrollTo(0, this.$refs.stickyBox.offsetTop)
}
})
},
infinite: function () {
if (this.infiniteAll) {
return
}
if (this.infiniteStatus) {
return
}

this.infiniteStatus = true
if (this.travelsList.length > 0) {
this.travelsListPageNo += this.travelsListPageSize
}
this.getTravelsList()
}
}
}
